import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgPaymentCard({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 4a3 3 0 013 3v10a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h12zm1 7H5v6a1 1 0 001 1h12a1 1 0 001-1v-6zm-3 2a1 1 0 110 2h-2a1 1 0 010-2h2zm2-7H6a1 1 0 00-1 1v2h14V7a1 1 0 00-1-1z"
        fill={color}
      />
    </svg>
  )
}

export default SvgPaymentCard
